function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDialysisTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 850 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 155.72,
    y: 167.84,
    width: 28.72,
    height: 64.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask1_8214_229894-2",
    "data-name": "mask1 8214 229894"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.44,189.35v21.29c0,7.93-6.43,14.36-14.36,14.36h0c-7.93,0-14.36-6.43-14.36-14.36v-21.29c0-7.93,6.43-14.36,14.36-14.36h0c7.93,0,14.36,6.43,14.36,14.36Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 665.56,
    y: 167.85,
    width: 28.72,
    height: 64.31,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask2_8214_229894-2",
    "data-name": "mask2 8214 229894"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.56,189.35v21.29c0,7.93,6.43,14.36,14.36,14.36h0c7.93,0,14.36-6.43,14.36-14.36v-21.29c0-7.93-6.43-14.36-14.36-14.36h0c-7.93,0-14.36,6.43-14.36,14.36Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 895.48,
    height: 440,
    style: {
      fill: "#003e6b",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "dialysis_tube",
    "data-name": "dialysis tube"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "mask2_8214_229894",
    "data-name": "mask2 8214 229894"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M665.56,189.35v21.29c0,7.93,6.43,14.36,14.36,14.36h0c7.93,0,14.36-6.43,14.36-14.36v-21.29c0-7.93-6.43-14.36-14.36-14.36h0c-7.93,0-14.36,6.43-14.36,14.36Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask1_8214_229894",
    "data-name": "mask1 8214 229894"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.44,189.35v21.29c0,7.93-6.43,14.36-14.36,14.36h0c-7.93,0-14.36-6.43-14.36-14.36v-21.29c0-7.93,6.43-14.36,14.36-14.36h0c7.93,0,14.36,6.43,14.36,14.36Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask0_8214_229894",
    "data-name": "mask0 8214 229894"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.77,122.07h278.95c43.74,0,79.25,35.51,79.25,79.25h0c0,43.74-35.51,79.26-79.26,79.26h-278.95c-43.74,0-79.26-35.51-79.26-79.26h0c0-43.74,35.51-79.26,79.26-79.26Z",
    style: {
      fill: "#99dff9",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.49,200h0c0-57.22,46.39-103.61,103.61-103.61h287.8c57.22,0,103.61,46.39,103.61,103.61h0c0,57.22-46.39,103.61-103.61,103.61h-287.8c-57.22,0-103.61-46.39-103.61-103.61Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.65,246.37c-7.57,5.86-18.56.46-18.56-9.1v-69.41c0-9.18,10.22-14.67,17.88-9.59l46.75,31.01v21.44s-46.07,35.65-46.07,35.65Z",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.44,189.35v21.29c0,7.93-6.43,14.36-14.36,14.36h0c-7.93,0-14.36-6.43-14.36-14.36v-21.29c0-7.93,6.43-14.36,14.36-14.36h0c7.93,0,14.36,6.43,14.36,14.36Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.79,167.84c3.7,0,6.91,2.52,7.55,6.16,1.03,5.83,2.33,15.27,2.33,26,0,10.73-1.29,20.17-2.33,26-.65,3.64-3.85,6.16-7.55,6.16h0c-4.46,0-8.07-3.61-8.07-8.07v-48.17c0-4.46,3.61-8.07,8.07-8.07h0Z",
    style: {
      fill: "#eee",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M78,240.46c-7.54,2.88-15.63-2.68-15.63-10.75v-53.45c0-7.74,7.48-13.27,14.88-11.01l78.47,24.03v21.44s-77.72,29.75-77.72,29.75Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.35,246.37c7.57,5.86,18.56.46,18.56-9.1v-69.41c0-9.18-10.22-14.67-17.88-9.59l-46.75,31.01v21.44s46.07,35.65,46.07,35.65Z",
    style: {
      fill: "#ccc",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mask: "url(#mask-1)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M665.56,189.35v21.29c0,7.93,6.43,14.36,14.36,14.36h0c7.93,0,14.36-6.43,14.36-14.36v-21.29c0-7.93-6.43-14.36-14.36-14.36h0c-7.93,0-14.36,6.43-14.36,14.36Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.21,167.85c-3.7,0-6.91,2.52-7.55,6.16-1.03,5.83-2.33,15.27-2.33,26,0,10.73,1.29,20.17,2.33,26,.65,3.64,3.85,6.16,7.55,6.16h0c4.46,0,8.07-3.61,8.07-8.07v-48.17c0-4.46-3.61-8.07-8.07-8.07h0Z",
    style: {
      fill: "#eee",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M772,240.47c7.54,2.88,15.63-2.68,15.63-10.75v-53.45c0-7.74-7.48-13.27-14.88-11.01l-78.47,24.02v21.44s77.72,29.75,77.72,29.75Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M641.65,201.33h0c0-23.38-10.12-44.38-26.22-58.89h-7.63c.03.65.1,1.29.1,1.95v28.2c0,48.7-39.48,88.18-88.18,88.18h-236.27c-40.41,0-73.74-30.26-78.62-69.35-.41,3.25-.64,6.55-.64,9.91h0c0,43.77,35.48,79.26,79.26,79.26h278.95c43.77,0,79.26-35.48,79.26-79.25Z",
    style: {
      fill: "#336b80",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.45,260.77h236.27c48.7,0,88.18-39.48,88.18-88.18v-28.2c0-.66-.07-1.3-.1-1.95H230.41c-13.79,12.42-23.17,29.62-25.58,48.98,4.88,39.09,38.2,69.35,78.62,69.35Z",
    style: {
      fill: "#3386a5",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.43,142.44c-14.05-12.66-32.64-20.37-53.03-20.37h-278.95c-20.4,0-38.99,7.71-53.03,20.37h377.38s7.63,0,7.63,0Z",
    style: {
      fill: "#f2f7fc",
      strokeWidth: 0
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialysisTube);
export default __webpack_public_path__ + "static/media/dialysis_tube.b8ca2805849f0764f4b13b88d3e9ae37.svg";
export { ForwardRef as ReactComponent };